'use client';

import React, { useState } from 'react';
import AuthLanding from './components/AuthLanding';
import LoginForm from './components/LoginForm';
import CompanyRegistrationForm from './components/CompanyRegistrationForm';
import EvaluatorRegistrationForm from './components/EvaluatorRegistrationForm';

type AuthView = 'landing' | 'login' | 'company-register' | 'evaluator-register';

export default function SignUpLoginPage() {
  const [view, setView] = useState<AuthView>('landing');

  if (view === 'login') {
    return (
      <div className="relative">
        <button
          type="button"
          onClick={() => setView('landing')}
          className="fixed top-5 left-5 z-50 px-4 py-2 rounded-lg border border-border bg-background/90 text-sm font-600 text-foreground hover:bg-muted transition-colors shadow-sm"
        >
          ← Regresar
        </button>

        <LoginForm />
      </div>
    );
  }

  if (view === 'company-register') {
    return (
      <CompanyRegistrationForm
        onBack={() => setView('landing')}
      />
    );
  }

  if (view === 'evaluator-register') {
    return (
      <EvaluatorRegistrationForm
        onBack={() => setView('landing')}
      />
    );
  }

  return (
    <AuthLanding
      onLogin={() => setView('login')}
      onCompanyRegister={() => setView('company-register')}
      onEvaluatorRegister={() => setView('evaluator-register')}
    />
  );
}
